import React, { Component } from 'react';

import { bool, number, string } from 'prop-types';

import { TabItemAPI } from '@philips-emr/tws-components-api';
import { AwesomeComponent, ComponentType } from '@philips-emr/tws-core';
import { DataContext, RouteContext } from '@philips-emr/tws-core/lib/component/context';
import { eventListener, expression } from '@philips-emr/tws-core/lib/component/prop-types';
import HistoryService, { matchRouteWith } from '@philips-emr/tws-core/lib/services/history-service';
import { msg } from '@philips-emr/tws-core/lib/services/message-service';
import { classNames } from '@philips-emr/tws-utils';

@AwesomeComponent({ type: ComponentType.NAVIGATION, api: TabItemAPI })
class TabItem extends Component {

  static contextType = DataContext.Context;

  static propTypes = {
    active: bool,
    badge: string,
    index: number,
    label: expression,
    onClick: eventListener,
    onDoubleClick: eventListener,
    onContextMenu: eventListener,
    route: string,
    uppercase: bool,
  };

  static defaultProps = {
    active: false,
    uppercase: true,
  };

  getCompleteRoute(routeContext, route) {
    return routeContext ? routeContext.nestedRoute(route) : route;
  }

  onClick = (routeContext) => {
    const { onClick } = this.props;
    this.executeEvent(routeContext, onClick);
  };

  onDoubleClick = (routeContext) => {
    const { onDoubleClick } = this.props;
    this.executeEvent(routeContext, onDoubleClick);
  };

  onContextMenuClick = (routeContext) => {
    const { onContextMenu } = this.props;
    this.executeEvent(routeContext, onContextMenu);
  };

  executeEvent(routeContext, event) {
    const { index, route } = this.props;

    if (route) {
      const completeRoute = this.getCompleteRoute(routeContext, route);
      return HistoryService.push(completeRoute, this.context);
    }

    event && event({ value: index });
  }

  getClassName(routeContext) {
    const { uppercase } = this.props;

    const classObject = {
      'c-tab-item': true,
      'c-tab-item--uppercase': uppercase,
      'is-active': this.isActive(routeContext),
    };

    return classNames(classObject);
  }

  isActive(routeContext) {
    const { active, route } = this.props;

    const completeRoute = this.getCompleteRoute(routeContext, route);

    return active || matchRouteWith(completeRoute);
  }

  render() {
    const { badge, label } = this.props;

    return (
      <RouteContext.Context.Consumer>
        {routeContext => (
          <div className={this.getClassName(routeContext)}
            onClick={() => this.onClick(routeContext)}
            onDoubleClick={() => this.onDoubleClick(routeContext)}
            onContextMenu={() => this.onContextMenuClick(routeContext)}
          >
            <span className="c-tab-item__text">{msg(label)}</span>
            <span className="c-tab-item__badge">{badge}</span>
          </div>
        )}
      </RouteContext.Context.Consumer>
    );
  }
}

export default TabItem;
